import { toPairs } from 'lodash-es';

export const PHONE = 'phone';
export const TABLET = 'tablet';
export const LAPTOP = 'laptop';
export const DESKTOP = 'desktop';

const DEVICE_SIZES = {
  [DESKTOP]: [1367, 7680],
  [LAPTOP]: [1025, 1366],
  [TABLET]: [768, 1024],
  [PHONE]: [0, 767],
};

const DEVICES = [DESKTOP, LAPTOP, TABLET, PHONE];

export const getCurrentDevice = () => {
  const width = window.innerWidth;
  const [currentDevice] = toPairs(DEVICE_SIZES).find(
    ([, [min, max]]) => width >= min && width <= max
  );

  return currentDevice;
};

export const getAvailableDevices = () => {
  const currentDevice = getCurrentDevice();

  return DEVICES.slice(DEVICES.indexOf(currentDevice));
};

export const isSmaller = (a, b) => DEVICES.indexOf(a) > DEVICES.indexOf(b);
